import React, { useEffect, useState } from 'react';
import AlphabetLetter from './AlphabetLetter';

const AlphabetInput = ({setFirstLetters}) => {

    const alphabet = [
        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", 
        "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"
      ];

    const [letters, setLetters] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [timeoutId, setTimeoutId] = useState(null);
    const [initialized, setInitialized] = useState(false);

    const handleChange = (e) => {
        const value = e.target.value.toUpperCase();
        setInputValue(value);
        if (timeoutId) clearTimeout(timeoutId);

        const newTimeout = setTimeout(() => {
            const newLetters = [...new Set(value.split(""))].filter(letter => alphabet.includes(letter) && !letters.includes(letter));
            
            if (newLetters.length > 0) {
                setLetters([...letters, ...newLetters].sort());
            }

            setInputValue("");
        }, 750);

        setTimeoutId(newTimeout);
    };

    const removeLetter = (letterToRemove) => {
        setLetters(letters.filter(letter => letter !== letterToRemove));
    };

    useEffect(() => {

        if(!initialized){
            if(sessionStorage.getItem("header")){
                const save = JSON.parse(sessionStorage.getItem("header"));
          
                if(save.letters){
                  setLetters(save.letters.split(","));
                }
            }

            setInitialized(true);
            
        } else{

            setFirstLetters(letters);
        }
    }, [letters]);

    return (
        <div className='alphabet-input'>
            <input 
                type="text" 
                value={inputValue} 
                onChange={handleChange}
                placeholder='Première(s) lettre(s)'
                pattern="[A-Za-z]+" 
            />

            <ul>
                {
                    letters.map((letter, index) => <AlphabetLetter letter={letter} key={`${letter}-${index}`} removeLetter={removeLetter} />)
                }
            </ul>
        </div>
    );
};

export default AlphabetInput;